import axios from 'axios';
import {
  ParamGetAssetModels,
  PayloadAssetModels,
  PayloadAssetTypes
} from '../app/pages/ValidationsPage/type';
import * as qs from 'qs';

export const getAssetModel = async (params: Partial<ParamGetAssetModels>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/assets/models?${query}`);
  return data;
};
// model tab
export const createNewAssetModel = async (payload: PayloadAssetModels) => {
  const { data } = await axios.post(`/assets/models`, payload);
  return data;
};
export const updateNewAssetModel = async (id: number, payload: PayloadAssetModels) => {
  const { data } = await axios.put(`/assets/models/${id}`, payload);
  return data;
};
export const deleteAssetModel = (id: number) => axios.delete(`/assets/models/${id}`);

export const uploadFileAssetModel = async (idModel: number, formData: FormData) => {
  const resUrlRecord = await axios.post(`/storages/asset-models/${idModel}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return resUrlRecord.data.url;
};

export const deleteFileModel = async (idFile: number) => {
  await axios.delete(`/storages/asset-models/${idFile}`);
};

// asset types tab
export const getAssetTypes = async (params: Partial<ParamGetAssetModels>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/assets/types?${query}`);
  return data;
};
export const getAssetTypeDetail = async (id: number) => {
  const { data } = await axios.get(`/assets/type/${id}`);
  return data;
};
export const createNewAssetTypes = async (payload: Partial<PayloadAssetTypes>) => {
  const { data } = await axios.post(`/assets/types`, payload);
  return data;
};
export const editNewAssetTypes = async (id: number, payload: Partial<PayloadAssetTypes>) => {
  const { data } = await axios.put(`/assets/types/${id}`, payload);
  return data;
};

export const deleteAssetTypes = (id: number) => axios.delete(`/assets/types/${id}`);

// dropdown options
export const getDropdownOptions = async (type?: string) => {
  const { data } = await axios.get(
    '/assets/dropdown-options?page=1&size=999&' + qs.stringify({ type })
  );
  return data;
};

export const addValuesToDropdownOption = async (dropdownOptionId: number, values: string[]) => {
  const { data } = await axios.post(`/assets/dropdown-options/${dropdownOptionId}/values`, {
    values
  });
  return data;
};

// validation
export const getAssetValidation = async (params: Partial<ParamGetAssetModels>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/assets/validations?${query}`);
  return data;
};

export const getOptionEntryFields = async (params: Partial<ParamGetAssetModels>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/assets/entry-fields?${query}`);
  return data;
};

type payloadUpdateSubmittedEntries = {
  name: string;
  typeId: number;
  condition: string;
  // criticality: number;
  criticalityKey: string;
  validated: boolean;
  hasIssue: boolean;
  make: number;
  modelId: number;
  altText: string;
  entries: {
    fieldId: number;
    value: string;
  }[];
};
export const updateSubmittedEntries = async ({
  payload,
  id,
  submitId
}: {
  submitId: number;
  id: number;
  payload: payloadUpdateSubmittedEntries;
}) => {
  const { data } = await axios.put(
    `/inspections/locations/${submitId}/submitted-assets/${id}/validate`,
    payload
  );
  return data;
};

export const archiveSubmittedEntries = async ({
  id,
  submitId,
  archive
}: {
  submitId: number;
  id: number;
  archive: boolean;
}) => {
  const { data } = await axios.put(
    `/inspections/locations/${submitId}/submitted-assets/${id}/archive`,
    {
      archive
    }
  );
  return data;
};

export const getTriggerTypes = async () => {
  // this endpoint is validated by the same generic paginationValidator as
  // trigger-sub-types (accepts page/size) — force a large page so callers get
  // the full list instead of just the service's default page size
  const { data } = await axios.get('/maintenance-trigger-types', {
    params: { page: 1, size: 999 }
  });
  return data;
};

// Create/update for trigger types are scaffolded ahead of backend support — only
// GET /maintenance-trigger-types exists today. These will 404 until the backend
// adds matching POST/PUT routes.
export const createTriggerType = async (payload: { name: string; calculationType: string }) => {
  const { data } = await axios.post('/maintenance-trigger-types', payload);
  return data;
};

export const updateTriggerType = async (
  id: number,
  payload: { name?: string; calculationType?: string }
) => {
  const { data } = await axios.put(`/maintenance-trigger-types/${id}`, payload);
  return data;
};

export const getTriggerSubTypes = async () => {
  // unlike /maintenance-trigger-types, this endpoint is genuinely paginated
  // (accepts page/size, returns total) — force a large page so the dropdown
  // gets the full list instead of just the service's default page size
  const { data } = await axios.get('/trigger-sub-types', { params: { page: 1, size: 999 } });
  return data;
};

export const createTriggerSubType = async (payload: { name: string; defaultUnit?: string }) => {
  const { data } = await axios.post('/trigger-sub-types', payload);
  return data;
};

export const updateTriggerSubType = async (
  id: number,
  payload: { name?: string; defaultUnit?: string }
) => {
  const { data } = await axios.put(`/trigger-sub-types/${id}`, payload);
  return data;
};

export const getMaintenanceUnits = async () => {
  const { data } = await axios.get('/maintenance-units');
  return data;
};
